/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/2/2022
 */

import {Type, TypeClass} from "@qwoach/class-transformer-wrapper";
import Discriminator from "@/utils/Discriminator";
import {TraumaCoachingWorkflowItem} from "@shared/Workflow/WorkflowItem-imports";
import FilterableItem from "@shared/Filterable/FilterableItem.js";
import WorkflowStageItem from "@shared/Workflow/base/WorkflowStageItem";
import {WorkflowTriggerEnum} from "@shared/Workflow/WorkflowTriggerEnum";


export const WORKFLOW_ID_PROSPECTING = "prospecting_workflow_id" // should be the same as on server side

@TypeClass(Discriminator.create([
	{ value: () => TraumaCoachingWorkflowItem, name: "TraumaCoachingWorkflowItem" },
	{ value: () => WorkflowItem, name: "WorkflowItem" },
]))
class WorkflowItem extends FilterableItem {


	type: string = "WorkflowItem"

	@Type(() => WorkflowStageItem)
	stageArray: WorkflowStageItem[] = []

	triggers: string[] = [] // this triggers is a combination of [...stageArray[i].triggers] and is needed to search for workflows in database by trigger


	constructor() {
		super();
	}

	hasStage(stageId){
		return this.stageArray.findIndex(stage => stage.id === stageId) >= 0
	}

	createStage(title = "", options = {}){
		let stageItem = new WorkflowStageItem();
		let {index} = options;
		if(index === undefined){
			index = this.stageArray.length
		}

		stageItem.title = title;
		stageItem.workflowId = this.id;
		this.stageArray.splice(index, 0, stageItem)

		return stageItem
	}

	removeStage(stageItem){
		let index = this.stageArray.indexOf(stageItem)
		return this.removeStageAt(index)
	}

	removeStageAt(index){
		if(index >= 0){
			return this.stageArray.splice(index, 1)
		}
	}

	hasLoadedEntries(){
		return this.stageArray.some(stage => stage._loadedEntries.length > 0)
	}


	beforeSaveToDb(options) {
		super.beforeSaveToDb(options);
		this.triggers = []
		this.stageArray.forEach(stage => {
			this.triggers = this.triggers.concat(stage.triggers)//we build an index to search workflow by triggers in database
		})
	}


	findStageById(stageId){
		return this.stageArray.find(stage => stage.id === stageId)
	}

	findStageByTrigger(trigger){
		return this.stageArray.find(stage => stage.triggers.includes(trigger))
	}

	static createDefault(){
		let workflowItem = new WorkflowItem()
		workflowItem.setId(WORKFLOW_ID_PROSPECTING)

		workflowItem.createStage("First contact")
			.setTriggers([WorkflowTriggerEnum.FIRST_CONTACT])

		workflowItem.createStage("Consultation scheduled")
			.setTriggers([WorkflowTriggerEnum.FIRST_CONSULTATION_SCHEDULED])

		workflowItem.createStage("Alignment confirmed")
		// workflowItem.createStage("Not a fit")
		// .addStage("Alignment confirmed")
		// .addStage("First call no-show")
		// .addStage("Contract sent")
		// .addStage("Payment received")
		// .addStage("First session booked")
		return workflowItem
	}

}


export default WorkflowItem
